// extracted by mini-css-extract-plugin
export default {"itemName":"ListCharacteristicsItem_itemName__uFJK8","customLabel":"ListCharacteristicsItem_customLabel__QMbiq","errorText":"ListCharacteristicsItem_errorText__b1Y74"};